import TenantServices from '../services/TenantServices';

export const ensureTenantId = async () => {
    const existingTenantId = sessionStorage.getItem("tenantId");
    if (!existingTenantId) {
        try {
            const tenantId = await TenantServices.getTenant("PremiumTrust");
            if (tenantId && tenantId.data && tenantId.data.id) {
                sessionStorage.setItem("tenantId", tenantId.data.id);
                return tenantId.data.id;
            }
        } catch (error) {
            console.error("Error getting tenant ID:", error);
        }
    }
    return existingTenantId;
};

export const validateSession = () => {
    const token = sessionStorage.getItem("token");
    const tenantId = sessionStorage.getItem("tenantId");
    const user = sessionStorage.getItem("user");
    
    if (!token || !tenantId || !user) {
        sessionStorage.clear();
        window.location.href = "/";
        return false;
    }
    return true;
};
